export default __webpack_public_path__ + "contentweb/app/pages/MRX/MRXSolutions/HereToHelp/experts.54dc826e.png";